import * as firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyCMmq62SaPDsu17vuzPyIZnsTIxF5ZH-cQ",
  authDomain: "devangel-dev.firebaseapp.com",
  databaseURL: "https://devangel-dev.firebaseio.com",
  projectId: "devangel-dev",
  storageBucket: "devangel-dev.appspot.com",
  messagingSenderId: "1023874076636",
  appId: "1:1023874076636:web:d4d1c245771659a29d0919",
  measurementId: "G-QB8CX1H0T2"
};

firebase.initializeApp(firebaseConfig);

export const Auth = firebase.auth();
export const Firestore = firebase.firestore();
export const Storage = firebase.storage();
export const Google = new firebase.auth.GoogleAuthProvider();
